"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _core = require("@material-ui/core");

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _FormGroup = _interopRequireDefault(require("@material-ui/core/FormGroup"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _moment = _interopRequireDefault(require("moment"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _FeedbackService = require("../../../KESI2/Services/FeedbackService");

var _strings = require("../Voting/strings");

var _BarChart = _interopRequireDefault(require("./BarChart"));

var _useTimer = require("./useTimer");

var _LiveTickerMessage = _interopRequireDefault(require("./LiveTickerMessage.scss"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var LiveTickerMultipleChoiceQuestion = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LiveTickerMultipleChoiceQuestion, _React$Component);

  var _super = _createSuper(LiveTickerMultipleChoiceQuestion);

  function LiveTickerMultipleChoiceQuestion(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LiveTickerMultipleChoiceQuestion);
    _this = _super.call(this, props);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (name) {
      return function (event) {
        event.persist();

        _this.setState(function (prevState) {
          return {
            selectedAnswers: _objectSpread(_objectSpread({}, prevState.selectedAnswers), {}, (0, _defineProperty3["default"])({}, name, event.target.checked))
          };
        });
      };
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setSelectedAnswer", function (selectedAnswer) {
      _this.setState({
        selectedAnswer: selectedAnswer
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sendFeedback", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _this$props, id, answers, selectedAnswers, answerUuids, result;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, id = _this$props.id, answers = _this$props.data.answers;
              selectedAnswers = _this.state.selectedAnswers;
              answerUuids = answers.filter(function (a) {
                return selectedAnswers[a.uuid];
              }).map(function (a) {
                return a.uuid;
              });
              _context.next = 5;
              return (0, _FeedbackService.pushFeedbackMessage)(id, answerUuids);

            case 5:
              result = _context.sent;

              _this.props.setTimer(0);

              _this.setState({
                votable: false
              });

              console.log(result);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.state = {
      quotedMessage: null,
      selectedAnswers: _this.props.data.answers.reduce(function (acc, cur) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty3["default"])({}, cur.uuid, false));
      }, {}),
      votable: _this.props.active
    };
    return _this;
  }

  (0, _createClass2["default"])(LiveTickerMultipleChoiceQuestion, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.active !== this.props.active) {
        this.props.setTimer(0);
        this.setState({
          votable: this.props.active
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var message = _dompurify["default"].sanitize(this.props.message);

      var _this$state = this.state,
          selectedAnswers = _this$state.selectedAnswers,
          votable = _this$state.votable;
      var _this$props2 = this.props,
          data = _this$props2.data,
          id = _this$props2.id,
          completed = _this$props2.completed;
      var answers = data.answers;
      return /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _LiveTickerMessage["default"].outer,
        key: "entry_".concat(message.id),
        id: message.id,
        style: this.props.isHidden ? {
          padding: 0,
          margin: 0,
          maxHeight: 0
        } : {
          padding: '7px',
          margin: '10px 0',
          maxHeight: '9999px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '20%',
          display: 'inline-block',
          verticalAlign: 'top',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].author : _LiveTickerMessage["default"].authorMobile,
        color: "textSecondary",
        gutterBottom: true
      }, this.props.author), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].date : _LiveTickerMessage["default"].dateMobile,
        color: "textSecondary",
        gutterBottom: true
      }, (0, _moment["default"])(this.props.dateCreated).format('DD.MM.YYYY HH:mm'))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '80%',
          display: 'inline-block',
          padding: 0,
          paddingLeft: 10,
          verticalAlign: 'top'
        }
      }, this.props.imageLink ? /*#__PURE__*/_react["default"].createElement("img", {
        style: {
          width: '100%',
          height: 'auto',
          display: 'block',
          position: 'relative',
          paddingBottom: '8px'
        },
        src: this.props.imageLink
      }) : null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].message : _LiveTickerMessage["default"].messageMobile,
        color: "textSecondary",
        gutterBottom: true,
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), votable ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset",
        className: _LiveTickerMessage["default"].answerBlock
      }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], null, answers.map(function (answer) {
        return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
          key: answer.uuid,
          control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
            checked: selectedAnswers[answer.uuid],
            onChange: _this2.handleChange(answer.uuid),
            value: answer.uuid
          }),
          label: answer.text
        });
      })))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        variant: "contained",
        color: "primary",
        onClick: function onClick() {
          return _this2.sendFeedback();
        },
        style: {
          marginTop: '8px'
        }
      }, (0, _strings.getString)('VOTE_NOW'))) : /*#__PURE__*/_react["default"].createElement(_BarChart["default"], {
        title: 'Stimmen',
        categories: answers.map(function (answer) {
          return answer.text;
        }),
        answers: answers,
        id: id
      }), completed !== 0 && /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '100%',
          padding: '8px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], {
        variant: "determinate",
        value: completed
      }))));
    }
  }]);
  return LiveTickerMultipleChoiceQuestion;
}(_react["default"].Component);

LiveTickerMultipleChoiceQuestion.propTypes = {
  id: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  key: _propTypes["default"].string,
  message: _propTypes["default"].string,
  dateCreated: _propTypes["default"].string,
  dateEdited: _propTypes["default"].string,
  isLatest: _propTypes["default"].bool,
  author: _propTypes["default"].string,
  imageLink: _propTypes["default"].string,
  isHidden: _propTypes["default"].bool,
  data: _propTypes["default"].object,
  duration: _propTypes["default"].string,
  setTimer: _propTypes["default"].func,
  completed: _propTypes["default"].number,
  active: _propTypes["default"].bool
};
LiveTickerMultipleChoiceQuestion.defaultProps = {
  isLatest: false,
  isExpert: false
};

var _default = (0, _useTimer.withTimer)(LiveTickerMultipleChoiceQuestion);

exports["default"] = _default;